import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/utils/getErrorMessage';

const actionTypes = {
  SIGN_IN_SUCCESS: 'auth/SIGN_IN_SUCCESS',
  LOGOUT: 'auth/LOGOUT',
  GET_BALANCE: 'auth/GET_BALANCE',
  SET_IS_PROCESS: 'auth/SET_IS_PROCESS',
  GET_NOTIFICATIONS: 'auth/GET_NOTIFICATIONS',
  GET_CASHBACK_INFO: 'auth/GET_CASHBACK_INFO',
};

const login = (username, password, callback) => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: true });
  const response = await api.auth.signIn(username, password);
  const errorMessage = getErrorMessage(locale, response);
  if (response.success) {
    dispatch(checkAuth());
    if (callback) callback();
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.SET_IS_PROCESS, payload: false });
};

const checkAuth = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.checkAuth();
  if (response.success) {
    if (response.data.role === 0) {
      dispatch(logOut());
    }
    dispatch({ type: actionTypes.SIGN_IN_SUCCESS, payload: response.data });
    dispatch(getBalance());
  } else {
    dispatch({ type: actionTypes.LOGOUT });
  }
};

const getBalance = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.getBalance();
  if (response.success) {
    dispatch({ type: actionTypes.GET_BALANCE, payload: response.data });
    if (response.data.isBanned) {
      dispatch(logOut());
    }
  }
};

const logOut = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.logOut();
  dispatch({ type: actionTypes.LOGOUT });
};

const getNotifications = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.agentAdmin.getNotifications();

  if (response.success && response.data?.length > 0) {
    dispatch({ type: actionTypes.GET_NOTIFICATIONS, payload: response.data });
  }
};

const dropNotifications = id => async (dispatch, getState) => {
  const { notifications } = getState().auth;

  const updatedItems = notifications.filter(item => item.id !== id);

  dispatch({ type: actionTypes.GET_NOTIFICATIONS, payload: [...updatedItems] });
};

const getCashbackInfo = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.auth.getCashbackInfo();
  if (response.success) {
    dispatch({ type: actionTypes.GET_CASHBACK_INFO, payload: response.data });
  }
};

export { actionTypes, login, logOut, checkAuth, getBalance, dropNotifications, getNotifications, getCashbackInfo };
